import { Component } from '@angular/core';
import { VERSION } from '../../app.constants';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    version: string;

    constructor() {
        this.version = 'v' + VERSION;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/footer.component.ts